import React from 'react'
import cn from 'classnames'

import Button from '@material-ui/core/Button'
import styles from './VNSubmitButton.module.scss'

/**
 * VNSubmitButton - Submit button component for forms
 *
 * @returns {React.Component}
 */
const VNSubmitButton = ({ className, text, ...props }) => {
  const classNames = cn(styles.container, className)

  return (
    <Button className={classNames} {...props}>
      {text}
    </Button>
  )
}

export default VNSubmitButton
